import { ListItem } from '../../../shared/list-confirmation/model/list-item';

export class Card {
	num?: string;
	numLabel? : string;
	state?: number;
	image?: string;
	code?: string;
	pass?: string;
	
	resumeList: Array<ListItem>;
	success: boolean;
	message: string;

	constructor() {}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/cards/model/card.ts